import React from "react";
import { ArrowRight, ShieldCheck, Recycle } from "lucide-react";
import { heroCollage } from "../mock";
import { useLang } from "../i18n";
import { useSiteMedia } from "../siteMedia";
import { resolveImage } from "../products";

// OPTION A — Modern Storefront (Light & Green, collage mosaic)
export const HeroA = () => {
  const { t } = useLang();
  const h = t.hero;
  const media = useSiteMedia();
  const heroImg = (key, fallback) => (media[key] ? resolveImage(media[key]) : fallback);
  return (
    <section id="home" className="bg-white">
      <div className="max-w-[1280px] mx-auto px-6 py-16 lg:py-24 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-green-600/10 text-green-700 font-semibold text-sm">
            <Recycle className="w-4 h-4" /> {h.badge}
          </span>
          <h1 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-800 leading-[1.1]">
            {h.headlineParts.map((part, i) =>
              part.hl ? (
                <span key={i} className="text-green-600">
                  {part.text}
                </span>
              ) : (
                <React.Fragment key={i}>{part.text}</React.Fragment>
              )
            )}
          </h1>
          <p className="mt-5 text-lg text-slate-500 max-w-lg">{h.sub}</p>
          <div className="mt-8 flex flex-wrap gap-4">
            <a
              href="/catalog"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-green-600 hover:bg-green-700 text-white font-bold shadow-lg shadow-green-600/20 transition-all hover:-translate-y-0.5"
            >
              {h.viewProducts} <ArrowRight className="w-5 h-5" />
            </a>
            <a
              href="/#about"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-slate-200 hover:border-green-600 text-slate-800 font-bold transition-colors"
            >
              {h.learnMore}
            </a>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-10">
            {t.stats.map((s) => (
              <div key={s.label}>
                <div className="text-3xl font-extrabold text-slate-800">{s.value}</div>
                <div className="text-sm mt-1 text-slate-500">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative">
          <div className="absolute -inset-4 bg-green-600/10 rounded-[2rem] rotate-3" />
          <div className="relative grid grid-cols-2 grid-rows-2 gap-3 h-[440px] lg:h-[480px]">
            <img
              src={heroImg("hero_1", heroCollage[0])}
              alt="Bulk refurbished computer inventory in shipping container"
              className="row-span-2 w-full h-full object-cover rounded-[1.25rem] shadow-2xl"
            />
            <img
              src={heroImg("hero_2", heroCollage[1])}
              alt="Refurbished computer components"
              className="w-full h-full object-cover rounded-[1.25rem] shadow-xl"
            />
            <img
              src={heroImg("hero_3", heroCollage[2])}
              alt="Boxed refurbished inventory ready to ship"
              className="w-full h-full object-cover rounded-[1.25rem] shadow-xl"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-4 flex items-center gap-3 border border-slate-100">
            <div className="w-11 h-11 rounded-xl bg-green-600/10 flex items-center justify-center">
              <ShieldCheck className="w-6 h-6 text-green-600" />
            </div>
            <div>
              <div className="font-bold text-slate-800 text-sm">{h.certifiedTitle}</div>
              <div className="text-xs text-slate-500">{h.certifiedSub}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
